// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error--main[data-v-186839d5]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.error--main .error__title[data-v-186839d5]{font-size:1.5rem;background-color:var(--primary-light);height:50%;padding:1.5rem 2rem;color:var(--white)}.error--main .error__message[data-v-186839d5]{font-size:1rem;padding:1.5rem;background-color:var(--white)}#errorBtn[data-v-186839d5]{margin:2em auto}", ""]);
// Exports
module.exports = exports;
